module.exports = __webpack_public_path__ + "static/img/index_three_three.baffeda3.png";